import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar'; // Uvezi Navbar
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ScheduleAppointment from './components/ScheduleAppointments';
import PatientsList from './components/PatientsList';
import CalendarView from './components/CalendarView';
import SveskaView from './components/SveskaView';
import ServicesPanel from './components/ServicesPanel';
import RemindersPanel from './components/RemindersPanel';
import GroupScheduling from './components/GroupScheduling';
import SmsLogPanel from './components/SmsLogPanel';
import DoctorsPanel from './components/DoctorsPanel';
import AccountSettings from './components/AccountSettings';
import UsersPanel from './components/UsersPanel';
import WorkingHoursPanel from './components/WorkingHoursPanel';
import SettingsPanel from './components/SettingsPanel';


function App() {
  return (
    <Router>
      <Navbar /> {/* MENI JE OVDE - UVEK VIDLJIV */}
      <div style={{ padding: '20px' }}> {/* Kontejner za sadržaj stranica */}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/calendar" element={<CalendarView />} />
          <Route path="/sveska" element={<SveskaView />} />
          <Route path="/schedule" element={<ScheduleAppointment />} />
          <Route path="/patients" element={<PatientsList />} />
          <Route path="/services" element={<ServicesPanel />} />
          <Route path="/reminders" element={<RemindersPanel />} />
          <Route path="/group-scheduling" element={<GroupScheduling />} />
          <Route path="/sms-log" element={<SmsLogPanel />} />
          <Route path="/doctors" element={<DoctorsPanel />} />
          <Route path="/account" element={<AccountSettings />} />
          <Route path="/users" element={<UsersPanel />} />
          <Route path="/working-hours" element={<WorkingHoursPanel />} />
          <Route path="/settings" element={<SettingsPanel />} />
          <Route path="/" element={<Login />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;